var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.initialized)?_c('App',{attrs:{"id":"keyreply"},on:{"closeInit":_vm.closeInit}}):(_vm.isCustomLogin && !_vm.isAuthenticated)?_c('div',[_c('Auth0CustomLogin')],1):_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require('./assets/logo.png'),"width":"64","height":"64"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }